












































































































































































import Vue from 'vue';
import ReviewHeader from '@/parts/review/ReviewHeader.vue';
import ReturnTop from '@/parts/util/ReturnTop.vue';
import { getDaysCountToEndDate } from '@/utils/momentUtils';
import { getUserNickName } from '@/utils/labelUtils';
import SimpleTooltip from '@/parts/util/SimpleTooltip.vue';

import moment from "moment";

import { ReviewForm, toCreateReviewRequestFromReviewForm, toUpdateReviewRequestFromReviewForm } from './ReviewForm';
import { createReview, updateReview, updateReviewStatus } from '@/api/Review';
import { UserProfile, GetUserProfileResponse } from '@/api/dto/UserProfile';
import { getUserProfile } from '@/api/UserProfile';
import { defaultIconUrl, securityCheck } from '@/properties';
import Editor from '@/parts/review/Editor.vue';
import { CodeEditorSegmegment } from '@/api/dto/CodeEditor';
import axios from 'axios';
import { ErrorResponse } from '@/api/dto/Error';

export default Vue.extend({
  name: 'ReviewConfirm',
  components: {
    Editor,
    ReviewHeader,
    ReturnTop,
    SimpleTooltip,
  },
  data() {
    return {
      isApiProcessing: false,
      defaultIconUrl,
      reviewData: {} as ReviewForm,
      profileData: {} as GetUserProfileResponse,
      alertList: [] as number[][],
      // モーダル 関連
      modalOpen: false,
      reaveModal: false,
      completeModal: false,
      // 汎用
      allowLeave: false,
      goBack: false,
      nextPath: '',
      isEnlarge: false,
    }
  },
  created() {
    this.initData();
  },
  async beforeRouteLeave(to, from, next) {
    if(!this.$browserBackFlg){ // ブラウザバック以外の場合
      // ガイド.よくある質問は別タブ
      if (to.path == '/guide' || to.path == '/faq') {
        window.open(to.path, '_blank');
        return;
      }
    }
    if(!this.allowLeave){ // ページ離脱を許されていない場合
      if(!(to.name == 'ReviewDraft' || to.name == 'ReviewEdit' || to.name == 'ReviewDraftPayout' || to.name == 'ReviewPayout')){ // 編集画面と決済画面を除く
        this.goBack = this.$browserBackFlg; // ブラウザバックであるか
        this.reaveModalOpen(to.path);
        next(false);
        return;
      }
    }
    this.allowLeave = false;
    next();
  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    formattedPurchaseOverview(): string {
      const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
      return this.reviewData.purchaseOverview.replace(urlRegex, (url: string) => {
        return `<a href="${url}" target="_blank">${url}</a>`;
      });
    },
    formattedCodeEditor(): {} {
      const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
      return this.reviewData.codeEditor.map((item) => {
        return {
          ...item,
          remarks: item.remarks.replace(urlRegex, (url: string) => {
            return `<a href="${url}" target="_blank">${url}</a>`;
          })
        }
      })
    },
    dealId(): string {
      return this.$route.params.dealId;
    },
    isNewReview(): boolean {
      return this.$route.path == '/review/confirm';
    },
    /** レビューの受注方式が入札かどうか */
    isTender(): boolean {
      return this.reviewData.purchaseType === '1';
    },
    hasAlert(): boolean {
      return this.alertList.some(s => s.length > 0);
    },
    nickname(): string {
      return getUserNickName(this.loginData.nickname, this.loginData.userId);
    },
    isEnlarged():boolean {
      return this.isEnlarge;
    },
  },
  methods: {
    async initData() {
      var storeReviewForm = this.$store.getters.reviewForm as ReviewForm;
      if(storeReviewForm.dealId == this.dealId && storeReviewForm.title){
        this.reviewData = JSON.parse(JSON.stringify(storeReviewForm));
        this.getUserProfile();
        this.alertList = this.reviewData.codeEditor.map(segment => this.checkCode(segment));
      } else {
        this.allowLeave = true;
        if(this.isNewReview){
          this.$router.replace({name:'ReviewDraft'});
        } else {
          this.$router.replace({name:'ReviewEdit',params:{dealId:this.dealId}});
        }
      }
    },
    /**
     * セキュリティチェックを行い, 該当行を返す
     */
    checkCode(segment: CodeEditorSegmegment): number[] {
        const individual = securityCheck.individual.find(v => v.extension == segment.extension);
        const lines: number[] = [];
        segment.text.forEach((line, i) => {
          const check1 = securityCheck.common.find(v => line.code.indexOf(v) != -1);
          const check2 = individual?.word.find(v => line.code.indexOf(v) != -1) ?? false;
          if(check1 || check2){
            lines.push(i + 1);
          }
        });
        return lines;
    },
    async getUserProfile() {
      try {
        const res = await getUserProfile();
        this.profileData = res;
      } catch (e) {
        console.log(e);
      }
    },
    // モーダル 関連
    reaveModalOpen(path: string) {
      this.modalOpen = true;
      this.reaveModal = true;
      this.nextPath = path;
    },
    completeModalOpen() {
      this.modalOpen = true;
      this.completeModal = true;
    },
    modalClose() {
      this.modalOpen = false;
      this.reaveModal = false;
    },
    // 公開する
    settlement() {
      this.reviewSubmit('settlement');
    },
    // 公開したページを見る
    toReview() {
      this.$router.push({
        name:'Review',
        params:{dealId:this.reviewData.dealId as string}
      });
    },
    // 取引管理へ
    toDealsManagement() {
      this.$router.push({ name:'DealsManagement' });
    },
    // 支払情報の入力へ
    toPayout() {
      this.reviewSubmit('payout');
    },
    // 更新する
    update() {
      this.reviewSubmit('update');
    },
    // 破棄
    destroy() {
      this.modalClose();
      this.$store.dispatch('initReviewForm');
      this.allowLeave = true;
      if(this.goBack){
        this.$router.go(-1);
      } else {
        this.$router.push(this.nextPath);
      }
    },
    // ページ離脱による下書き保存 or 編集内容を保存
    saveLeave() {
      this.reviewSubmit('save');
    },
    // 汎用
    async reviewSubmit(action: string) {
      // アカウントステータスの確認
      await this.$store.dispatch('updateAccountStatus');
      if(this.loginData.accountStatus == '3') {
        this.allowLeave = true;
        this.$emit('errorToast', 'アカウント制限中のため、依頼作成ができません。');
        this.$router.push({name:'Top'});
      }

      if(action == 'payout'){
        this.$store.dispatch('updateReviewForm', { form: this.reviewData });
        this.allowLeave = true;
        if (this.isNewReview) {
          this.$router.push({name:'ReviewDraftPayout'});
        } else {
          this.$router.push({name:'ReviewPayout',params:{dealId:this.reviewData.dealId as string}});
        }
      } else if(action == 'update'){
        try {
          // レビュー更新API 取引ステータス:そのまま（受注待ち⇒受注待ち）
          await updateReview(this.reviewData.dealId as string, toUpdateReviewRequestFromReviewForm(this.reviewData));
          this.$emit('toast', '情報を更新しました。');
          this.$store.dispatch('initReviewForm');
          this.allowLeave = true;
          this.$router.push({name:'Review',params:{dealId:this.reviewData.dealId as string}});
        } catch (e) {
            if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit('errorToast', 'レビュー公開に失敗しました。しばらく経ってからやり直してください。');
            } else {
              this.$emit('errorToast', resError.message);
            }
          }
        }
      } else if(action == 'save'){
        try {
          if (this.isNewReview) {
            // レビュー作成API 取引ステータス:下書き
            await createReview(toCreateReviewRequestFromReviewForm(this.reviewData));
            this.$emit('toast', '下書き保存しました');
          } else {
            // レビュー更新API 取引ステータス:そのまま（下書き⇒下書きor受注待ち⇒受注待ち）
            await updateReview(this.reviewData.dealId as string, toUpdateReviewRequestFromReviewForm(this.reviewData));
            this.$emit('toast', '編集内容を保存しました');
          }
          this.destroy();
        } catch (e) {
            if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit('errorToast', 'レビュー公開に失敗しました。しばらく経ってからやり直してください。');
            } else {
              this.$emit('errorToast', resError.message);
            }
          }
        }
      } else if(action === 'settlement'){
        try {
          this.isApiProcessing = true;
          if (!this.reviewData.dealId) {
            // レビュー作成API 取引ステータス:下書き
            var res = await createReview(toCreateReviewRequestFromReviewForm(this.reviewData));
            this.reviewData.dealId = res.dealId;
          } else {
            // レビュー更新API 取引ステータス:そのまま（下書き⇒下書き）
            await updateReview(this.reviewData.dealId as string, toUpdateReviewRequestFromReviewForm(this.reviewData));
          }
          // レビューステータス更新API 取引ステータス: 下書き⇒受注待ち
          await updateReviewStatus(this.reviewData.dealId as string, { dealStatus: '2' });
          this.$store.dispatch('initReviewForm');
          this.allowLeave = true;
          this.completeModalOpen();
        } catch (e) {
            if (axios.isAxiosError(e) && e.response) {
              var resError = e.response.data as ErrorResponse;
              if (resError.message == null) {
                this.$emit('errorToast', 'レビュー公開に失敗しました。しばらく経ってからやり直してください。');
              } else {
                this.$emit('errorToast', resError.message);
              }
            }
        } finally {
          this.isApiProcessing = false;
        }
      }
    },
    /** 拡大縮小を切り替える */
    changeEnlargeFlag() {

      // margin-topの値を変更する
      let editStyle = (className: string, value: string) => {
        let subReviewDetails = document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>;
        Array.prototype.forEach.call(subReviewDetails, (item) => {
          item.style.marginTop = value;
        })
      };

      // クラスを追加する
      let addClass = (className: string, addName: string) => {
        Array.prototype.forEach.call(document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>, (item) => {
          item.classList.add(addName);
        })
      };

      // クラスを削除する
      let removeClass = (className: string, removeName: string) => {
        Array.prototype.forEach.call(document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>, (item) => {
          item.classList.remove(removeName);
        })
      };


      if (this.isEnlarge) { // 拡大中のときの処理
        document.getElementById("confirm-contents")!.style.display = "flex";
        editStyle("sub-review-detail", "0px");
        removeClass("outline", "enlarge-outline");
        removeClass("sub-column", "enlarge-sub-column");
        removeClass("order-user", "enlarge-order-user");
        removeClass("buttons", "enlarge-buttons");
        removeClass("conditions", "enlarge-conditions");
        editStyle("order-user", "30px");
        this.isEnlarge = false;
      } else { // 拡大していないときの処理
        document.getElementById("confirm-contents")!.style.display = "block";
        editStyle("sub-review-detail", "30px");
        addClass("outline", "enlarge-outline");
        addClass("sub-column", "enlarge-sub-column");
        addClass("order-user", "enlarge-order-user");
        addClass("buttons", "enlarge-buttons");
        addClass("conditions", "enlarge-conditions");
        editStyle("order-user", "0px");
        this.isEnlarge = true;
      }
    },
  },
  filters: {
    fileNameOthersHide: function(fileName: string) {
      return fileName.replace(/その他$/, '');
    },
    amountLocaleString: function(amount: number) {
      if(amount){
        return amount.toLocaleString();
      } else { // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return amount;
      }
    },
    remainingDays(period: string): string {
      const remain = getDaysCountToEndDate(new Date(period));
      return remain < 0 ? '期限切れ' : `残り ${remain} 日`
    },
    formatDate(date: string, fmt: string): string {
      return moment(date).format(fmt)
    },
    lastUpdate: function(date: Date) {
      moment.locale( 'ja' );
      if(date){
        return moment(date).fromNow();
      } else {
        return moment().fromNow();
      }
    },
  }
})
